import { toolDefinition } from '@tanstack/ai';
import { z } from 'zod';

export const addToDashboardInputSchema = z.object({
  title: z.string(),
  description: z.string().optional()
});

export const addToDashboardOutputSchema = z.object({ added: z.boolean() });

export const addToDashboardToolDefinition = toolDefinition({
  name: 'add_to_dashboard',
  description:
    "Adds the widget shown in this message to the user's dashboard. Requires user approval.",
  needsApproval: true,
  inputSchema: addToDashboardInputSchema,
  outputSchema: addToDashboardOutputSchema
});
